module.exports = __webpack_public_path__ + "static/img/bg.ed4a251.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/bg.png
// module id = DI8K
// module chunks = 1